import React from "react";
import {
    Typography, Box, Grid, FormControl, Select, MenuItem,
    RadioGroup, FormControlLabel, Radio, FormHelperText
} from '@material-ui/core';
import { MobileRegularPage } from '../../../components';
import styles from './AppQuestions.style';
import Rating from '@material-ui/lab/Rating';
import Checkbox from "@material-ui/core/Checkbox";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { RepLIProviderTextField } from '../../../components';
import { recommentedTo, featuresOrOptionsApp, featuresOrOptionsWebsite } from "../../../data/db";


const AppQuestions = props => {
    const MenuProps = {
        PaperProps: {
            style: {
                width: 250
            }
        },
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "center"
        },
        variant: "menu"
    };


    const classes = styles();

    return (
        <MobileRegularPage>
            <Grid container>
                <Grid item xs={12} md={12}>

                    <Box className={classes.inputSection} style={{ textAlign: "center" }}>
                        <Typography variant="h5" >
                            Did your Reproductive Life Journey map correctly using RepLI ?*
                        </Typography>
                        <FormControl
                            component="fieldset"
                            error={props.submitted && !props.validator.fieldValid('reproductive_life_journey_map')}
                        >
                            <RadioGroup row value={props.isRLJMappedCorrectly} onChange={props.onIsRLJMappedCorrectlyChange}>
                                <FormControlLabel control={<Radio color="primary" />} value="Yes, it mapped perfectly!" label="Yes, it mapped perfectly!" />
                                <FormControlLabel control={<Radio color="primary" />} value="There were a few errors" label="There were a few errors" />
                                <FormControlLabel control={<Radio color="primary" />} value="There were many errors when mapping my journey" label="There were many errors when mapping my journey" />
                                <FormControlLabel control={<Radio color="primary" />} value="My journey did not map at all" label="My journey did not map at all" />
                                <FormControlLabel control={<Radio color="primary" />} value="I'm not sure" label="I'm not sure" />
                                <FormControlLabel control={<Radio color="primary" />} value="Other" label="Other" />
                            </RadioGroup>
                            <FormHelperText error style={{ textAlign: "center" }} >
                                {props.validator.message('reproductive_life_journey_map', props.isRLJMappedCorrectly, 'required')}
                            </FormHelperText>
                        </FormControl>
                    </Box>
                    {props.isRLJMappedCorrectly === "Other" &&
                        <Box>
                            <Typography variant="h5" >
                                Other Reasons ?*
                            </Typography>
                            <RepLIProviderTextField
                                label="Other Reason"
                                autoFocus
                                value={props.mappedRLJOtherResp}
                                onChange={e => props.onMappedRLJOtherRespChange(e, "Mapped RLJ Other Response")}
                                error={props.submitted && !props.validator.fieldValid('reproductive_life_journey_map_other_response')}
                                inputProps={{ maxLength: 2500 }}
                                helperText={props.validator.message('reproductive_life_journey_map_other_response', props.mappedRLJOtherResp, `field_req:${props.isRLJMappedCorrectly}`)}
                            />
                        </Box>
                    }
                    {(props.isRLJMappedCorrectly === "There were a few errors" ||
                        props.isRLJMappedCorrectly === "My journey did not map at all") &&
                        <Box>
                            <Typography variant="h5" >
                                What were the issues ?*
                            </Typography>
                            <RepLIProviderTextField
                                value={props.issues}
                                onChange={e => props.onIssuesChange(e, "RLJ Issues")}
                                autoFocus
                                inputProps={{ maxLength: 2500 }}
                                error={props.submitted && !props.validator.fieldValid('issues')}
                                helperText={props.validator.message('issues', props.issues, `issues_field_req:${props.isRLJMappedCorrectly}`)}
                            />
                        </Box>
                    }
                    {(props.rljPosition === "Not Yet" ||
                        props.rljPosition === "I'm Ready" ||
                        props.rljPosition === "I'm In It" ||
                        props.rljPosition === "Not Interested") &&
                        < Box className={classes.inputSection}>
                            <Typography variant="h5" >
                                Did RepLI help you to envision your reproductive life goals?*
                            </Typography>
                            <FormControl
                                component="fieldset"
                                error={props.submitted && !props.validator.fieldValid('did_repli_envision_your_goals')}
                            >
                                <RadioGroup row value={props.didRepLIEnvisionRLG}
                                    onChange={props.onDidRepLIEnvisionRLGChange}>
                                    <FormControlLabel value="yes" control={<Radio color="primary" />} label="Yes" />
                                    <FormControlLabel value="no" control={<Radio color="primary" />} label="No" />
                                </RadioGroup>
                                <FormHelperText error >
                                    {props.validator.message('did_repli_envision_your_goals', props.didRepLIEnvisionRLG, `repli_envision_goals:${props.rljPosition}`)}
                                </FormHelperText>
                            </FormControl>
                        </Box>
                    }
                    {(props.rljPosition === "I'm Done" ||
                        props.rljPosition === "I'm In It" ||
                        props.rljPosition === "Not Interested") &&
                        <Box className={classes.inputSection}>
                            <Typography variant="h5" >
                                Was RepLI helpful for seeing your journey thus far?*
                            </Typography>
                            <FormControl
                                component="fieldset"
                                error={props.submitted && !props.validator.fieldValid('was_repli_helpful_for_seeing_your_journey')}
                            >
                                <RadioGroup row value={props.isRepLIHelpfulForSeeingRLG}
                                    onChange={props.onIsRepLIHelpfulForSeeingRLGChange}>
                                    <FormControlLabel value="yes" control={<Radio color="primary" />} label="Yes" />
                                    <FormControlLabel value="no" control={<Radio color="primary" />} label="No" />
                                </RadioGroup>
                                <FormHelperText error >
                                    {props.validator.message('was_repli_helpful_for_seeing_your_journey', props.isRepLIHelpfulForSeeingRLG, `was_repli_helpful_in_seeing_journey:${props.rljPosition}`)}
                                </FormHelperText>
                            </FormControl>
                        </Box>
                    }
                    <Box>
                        <FormControl variant="outlined" fullWidth
                            error={props.submitted && !props.validator.fieldValid('features_find_helpful_for_the_app')}
                        >
                            <Typography variant="h5" className={classes.pullLeft} margin="dense" >
                                What other features/options would you find helpful for the RepLI app?*
                            </Typography>
                            <Select
                                multiple
                                value={props.featuresFindHelpfulForApp}
                                onChange={props.onFeaturesFindHelpfulForAppChange}
                                renderValue={(selected) => selected.join(", ")}
                                MenuProps={MenuProps}
                            >
                                {featuresOrOptionsApp.map((option) => (
                                    <MenuItem key={option} value={option}>
                                        <ListItemIcon>
                                            <Checkbox color="primary" checked={props.featuresFindHelpfulForApp.indexOf(option) > -1} />
                                        </ListItemIcon>
                                        <ListItemText primary={option} />
                                    </MenuItem>
                                ))}
                            </Select>
                            <FormHelperText error >
                                {props.validator.message('features_find_helpful_for_the_app', props.featuresFindHelpfulForApp, 'required')}
                            </FormHelperText>
                        </FormControl>
                    </Box>
                    {props.featuresFindHelpfulForApp.some(x => x === "Other") &&
                        <Box>
                            <Typography variant="h5">
                                Other features/options for the RepLI app?*
                            </Typography>
                            <RepLIProviderTextField
                                label="Other features"
                                autoFocus
                                value={props.otherFeaturesFindHelpfulForApp}
                                inputProps={{ maxLength: 2500 }}
                                onChange={e => props.onOtherFeaturesFindHelpfulForAppChange(e, "Other features find helpful for App")}
                                error={props.submitted && !props.validator.fieldValid('other_features_find_helpful_for_app')}
                                helperText={props.validator.message('other_features_find_helpful_for_app', props.otherFeaturesFindHelpfulForApp, `other_features_find_helpful_for_app:${props.featuresFindHelpfulForApp}`)}
                            />
                        </Box>
                    }
                    <Box>
                        <FormControl variant="outlined" fullWidth
                            error={props.submitted && !props.validator.fieldValid('features_find_helpful_for_the_website')}>
                            <Typography variant="h5" className={classes.pullLeft} margin="dense" >
                                What other features/options would you find helpful for the RepLI website ?*
                            </Typography>
                            <Select
                                multiple
                                value={props.featuresFindHelpfulForWebsite}
                                onChange={props.onFeaturesFindHelpfulForWebsiteChange}
                                renderValue={(selected) => selected.join(", ")}
                                MenuProps={MenuProps}
                            >
                                {featuresOrOptionsWebsite.map((option) => (
                                    <MenuItem key={option} value={option}>
                                        <ListItemIcon>
                                            <Checkbox color="primary" checked={props.featuresFindHelpfulForWebsite.indexOf(option) > -1} />
                                        </ListItemIcon>
                                        <ListItemText primary={option} />
                                    </MenuItem>
                                ))}
                            </Select>
                            <FormHelperText error >
                                {props.validator.message('features_find_helpful_for_the_website', props.featuresFindHelpfulForWebsite, 'required')}
                            </FormHelperText>
                        </FormControl>
                    </Box>
                    {props.featuresFindHelpfulForWebsite.some(x => x === "Other") &&
                        <Box>
                            <Typography variant="h5" >
                                Other features/options for the RepLI website*
                            </Typography>
                            <RepLIProviderTextField
                                label="Other features"
                                autoFocus
                                value={props.otherFeaturesFindHelpfulForWebsite}
                                inputProps={{ maxLength: 2500 }}
                                onChange={e => props.onOtherFeaturesFindHelpfulForWebsiteChange(e, "Other features find helpful for Website")}
                                error={props.submitted && !props.validator.fieldValid('other_features_find_helpful_for_website')}
                                helperText={props.validator.message('other_features_find_helpful_for_website', props.otherFeaturesFindHelpfulForWebsite, `other_features_find_helpful_for_app:${props.featuresFindHelpfulForWebsite}`)}
                            />
                        </Box>
                    }
                    <Box>
                        <Typography variant="h5" >
                            Do you have any other feedback, suggestions, or improvements ?*
                        </Typography>
                        <RepLIProviderTextField
                            label="Other Feedback/Suggestions"
                            autoFocus
                            value={props.otherFeedbackSuggested}
                            inputProps={{ maxLength: 2500 }}
                            onChange={e => props.onOtherFeedbackSuggestedChange(e, "Other Feedback")}
                            error={props.submitted && !props.validator.fieldValid('other_Feedback_Suggestions')}
                            helperText={props.validator.message('other_Feedback_Suggestions', props.otherFeedbackSuggested, 'required')}
                        />
                    </Box>
                    <Box xs={10} md={10}>
                        <FormControl variant="outlined" fullWidth style={{ alignItems: "center" }}
                            error={props.submitted && !props.validator.fieldValid('appRating')}>
                            <Typography variant="h5" className={classes.pullLeft} margin="dense" fullWidth>
                                The overall experience with the application*
                            </Typography>
                            <Rating
                                value={props.appRating}
                                onChange={props.onAppRatingChange}
                            />
                            <FormHelperText error style={{ textAlign: "center" }} >
                                {props.validator.message('appRating', props.appRating, 'required')}
                            </FormHelperText>
                        </FormControl>
                    </Box>
                    <Box xs={10} md={10}>
                        <FormControl variant="outlined" fullWidth style={{ alignItems: "center" }}
                            error={props.submitted && !props.validator.fieldValid('websiteRating')}>
                            <Typography variant="h5" className={classes.pullLeft} margin="dense" fullWidth>
                                The overall experience with the webpage*
                            </Typography>
                            <Rating
                                value={props.websiteRating}
                                onChange={props.onWebsiteRatingChange}
                            />
                            <FormHelperText error style={{ textAlign: "center" }}>
                                {props.validator.message('websiteRating', props.websiteRating, 'required')}
                            </FormHelperText>
                        </FormControl>
                    </Box>
                    <Box className={classes.inputSection} style={{ textAlign: "center" }}>
                        <Typography variant="h5" >
                            I would recommend RepLI*
                        </Typography>
                        <FormControl
                            component="fieldset"
                            error={props.submitted && !props.validator.fieldValid('canRecommendRepLI')}
                        >
                            <RadioGroup row
                                value={props.canRecommendRepLI}
                                onChange={props.onCanRecommendRepLIChange}
                            >
                                <FormControlLabel value="yes" control={<Radio color="primary" />} label="Yes" />
                                <FormControlLabel value="no" control={<Radio color="primary" />} label="No" />
                            </RadioGroup>
                            <FormHelperText error style={{ textAlign: "center" }}>
                                {props.validator.message('canRecommendRepLI', props.canRecommendRepLI, 'required')}
                            </FormHelperText>
                        </FormControl>
                    </Box>
                    {props.canRecommendRepLI === "yes" &&
                        <Box>
                            <FormControl variant="outlined"
                                error={props.submitted && !props.validator.fieldValid('recommendRepLITo')}
                                fullWidth>
                                <Typography variant="h5" className={classes.pullLeft} margin="dense" >
                                    I would recommend RepLI to*
                                </Typography>
                                <Select
                                    multiple
                                    value={props.recommendRepLITo}
                                    onChange={props.onRecommendRepLIToChange}
                                    renderValue={(selected) => selected.join(", ")}
                                    MenuProps={MenuProps}
                                >
                                    {recommentedTo.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            <ListItemIcon>
                                                <Checkbox color="primary" checked={props.recommendRepLITo.indexOf(option) > -1} />
                                            </ListItemIcon>
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText error >
                                    {props.validator.message('recommendRepLITo', props.recommendRepLITo, `recommend_repli_to:${props.canRecommendRepLI}`)}
                                </FormHelperText>
                            </FormControl>
                        </Box>
                    }
                    {props.canRecommendRepLI === "yes"
                        && props.recommendRepLITo.some(x => x === "Other") &&
                        <Box>
                            <Typography variant="h5" >
                                Recommend RepLI to ?*
                            </Typography>
                            <RepLIProviderTextField
                                label=""
                                autoFocus
                                value={props.recommendRepLIToOtherResp}
                                onChange={e => props.onRecommendRepLIToOtherRespChange(e, "Recommend RepLI to Others Response")}
                                error={props.submitted && !props.validator.fieldValid('recommendRepLIToOtherResp')}
                                inputProps={{ maxLength: 2500 }}
                                helperText={props.validator.message('recommendRepLIToOtherResp', props.recommendRepLIToOtherResp, `recommend_repli_to_others:${props.canRecommendRepLI + ',' + props.recommendRepLITo}`)}
                            />
                        </Box>
                    }
                </Grid>
            </Grid>
        </MobileRegularPage >
    )
}

export default AppQuestions